const Location = () => (
  <svg width="11px" height="14px" className="icon-location" viewBox="0 0 11 14" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="molecule/delivery-info/mobile/default" transform="translate(-196.000000, -4.000000)" fill="#E67C21">
        <g id="location-icon" transform="translate(196.000000, 4.000000)">
          <path d="M5.13333333,11.62 C3.52,9.45 1.46666667,6.23 1.46666667,4.9 C1.46666667,2.94 3.08,1.4 5.13333333,1.4 C7.18666667,1.4 8.8,2.94 8.8,4.9 C8.8,6.23 6.74666667,9.45 5.13333333,11.62 M5.13333333,0 C2.27333333,0 0,2.17 0,4.9 C0,7.35 4.10666667,12.67 4.54666667,13.23 L5.13333333,14 L5.72,13.23 C6.16,12.67 10.2666667,7.35 10.2666667,4.9 C10.2666667,2.17 7.99333333,0 5.13333333,0" id="Fill-1"></path>
          <path d="M5.13333333,3.727836 C4.4374,3.727836 3.90529333,4.235756 3.90529333,4.900056 C3.90529333,5.564216 4.4374,6.072136 5.13333333,6.072136 C5.82912,6.072136 6.36122667,5.564216 6.36122667,4.900056 C6.36122667,4.235756 5.82912,3.727836 5.13333333,3.727836" id="Fill-3"></path>
        </g>
      </g>
    </g>
  </svg>
);

export default Location;